module.exports = __webpack_public_path__ + "img/water.8a926a88.svg";